import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CompraVenta from "@/pages/CompraVenta";
import TransactionForm from "@/pages/TransactionForm";
import Transactions from "@/pages/Transactions";
import Inventario from "@/pages/Inventario";
import Reportes from "@/pages/Reportes";
import Auditoria from "@/pages/Auditoria";
import Usuarios from "@/pages/Usuarios";
import Configuracion from "@/pages/Configuracion";
import Clientes from "@/pages/Clientes";
import Referidos from "@/pages/Referidos";
import Correcciones from "@/pages/Correcciones";
import GastosMayor from "@/pages/GastosMayor";
import CuadreWallet from "@/pages/CuadreWallet";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/compra-venta" element={<ProtectedRoute roles={["admin", "operator_mayor", "operator_detalle"]}><CompraVenta /></ProtectedRoute>} />
              <Route path="/transaccion" element={<ProtectedRoute roles={["admin", "operator_mayor", "operator_detalle"]}><TransactionForm /></ProtectedRoute>} />
              <Route path="/transacciones" element={<Transactions />} />
              <Route path="/inventario" element={<ProtectedRoute roles={["admin", "readonly"]}><Inventario /></ProtectedRoute>} />
              <Route path="/reportes" element={<ProtectedRoute roles={["admin", "readonly"]}><Reportes /></ProtectedRoute>} />
              <Route path="/clientes" element={<ProtectedRoute roles={["admin", "operator_detalle", "readonly"]}><Clientes /></ProtectedRoute>} />
              <Route path="/referidos" element={<ProtectedRoute roles={["admin", "operator_detalle", "readonly"]}><Referidos /></ProtectedRoute>} />
              <Route path="/correcciones" element={<Correcciones />} />
              <Route path="/gastos-mayor" element={<ProtectedRoute roles={["admin", "readonly"]}><GastosMayor /></ProtectedRoute>} />
              <Route path="/cuadre" element={<ProtectedRoute roles={["admin", "readonly"]}><CuadreWallet /></ProtectedRoute>} />
              <Route path="/auditoria" element={<ProtectedRoute roles={["admin", "readonly"]}><Auditoria /></ProtectedRoute>} />
              <Route path="/usuarios" element={<ProtectedRoute roles={["admin"]}><Usuarios /></ProtectedRoute>} />
              <Route path="/configuracion" element={<Configuracion />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
